module.exports = __webpack_public_path__ + "static/img/paintsplatter.057661b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/inventory/stickers/paintsplatter.png
// module id = NEkS
// module chunks = 0